import React, { useEffect } from 'react';
import { SaveUser, SetUserLoading } from '../../redux/slices/user';
import { RootState, store } from '../../redux/store';
import { AuthService } from 'services/auth/auth';
import { IMe } from 'core/interface/me';
import { useSelector } from 'react-redux';
import { JwtProviderProps } from 'core/interface/jwtProviderProps';
import { useSnackbar } from 'notistack';
import { JobService } from 'services/jobs/job';
import { CandidateService } from 'services/candidate/candidate';
import { ExtraActivitieService } from 'services/extraActivities/extraActivities';
import { SocialMediaExpertiseService } from 'services/socialMediaExpertise/socialMediaExpertise';
import { ProfileService } from 'services/profile/profile';
import { LanguageService } from 'services/language';

export default function JwtProvider({ children }: JwtProviderProps) {
  const me = useSelector((state: IMe) => state.user).user;
  const { enqueueSnackbar } = useSnackbar();
  const { messages } = useSelector((state: RootState) => state.errors);

  const loadUserData = async (userId: number, candidateId: number) => {
    try {
      // Load candidate data
      await CandidateService.getCandidate(candidateId);

      // Load assessments
      if (userId) {
        await JobService.getassesments(userId);
      }
      // Load extra activities
      await ExtraActivitieService.getExtraActivities(candidateId);

      // Load social media expertise
      await SocialMediaExpertiseService.getSocialMediaExpertise(candidateId);

      // Load social media profiles
      await ProfileService.getSocialMedias(candidateId);

      // Load languages
      await LanguageService.getCandidateLanguage(candidateId);
    } catch (err) {
      console.error('Error loading user data:', err);
    }
  };

  const getMe = async () => {
    const { dispatch } = store;
    try {
      dispatch(SetUserLoading(true));
      const response = await AuthService.getAccount();
      if (!response || !response.id) {
        throw new Error('Invalid user data received');
      }

      // First save the user to ensure it's available in the store
      dispatch(SaveUser(response));

      // Then load all user data if this is a candidate
      if (response.candidate_id) {
        await loadUserData(response.id, response.candidate_id);
      }
    } catch (err) {
      console.error('Failed to get account:', err);
    } finally {
      dispatch(SetUserLoading(false));
    }
  };

  useEffect(() => {
    if (!me) {
      getMe();
    }
  }, []);

  useEffect(() => {
    if (messages) {
      for (const message of messages) {
        if (!(message as any).showed && (message as any).value) {
          enqueueSnackbar((message as any).value, {
            variant: (message as any).variant
          });
        }
      }
    }
  }, [messages]);
  return <>{children}</>;
}
